module.exports = __webpack_public_path__ + "static/media/Logo_ISN_15.78e65551.jpg";